<h2 mat-dialog-title>Invite a colleague to join your Logbook team</h2>
<mat-dialog-content>
    <form #invitationForm="ngForm">
        <label>You are about to invite a new user to your team. He/she will have access to all the information shared on Logbook, do you confirm you grant this user access to your team?</label>
        <div class="input">
            <i class="dln-icon-add_mail"></i>
            <input type="email" name="colleagueEmail"
                   autocomplete="email" [(ngModel)]="colleagueEmail"
                   minlength="2" placeholder="Your colleague's email address" required/>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="buttons">
        <button (click)="cancel()" class="cancel">Cancel</button>
        <button (click)="sendInvitation()" class="confirm">Invite</button>
    </div>
</mat-dialog-actions>


